module.exports = __webpack_public_path__ + "static/media/step-one-icons.ca22d7c3.svg";